import React from 'react';
import { HERO_WIND, SHARED_HERO_DECORATIONS } from '../../../shared/config/decorations';
import { WindDeco } from './MenuPromoBackground.styles';

/** reward-decoration.png — 고정 위치 바람 장식 */
export function AnimatedWind() {
  const config = HERO_WIND;

  return (
    <WindDeco
      src={SHARED_HERO_DECORATIONS.rewardWind}
      alt=""
      loading="lazy"
      $left={config.left}
      $topPercent={config.topPercent}
      $width={config.width}
      $opacity={config.opacity}
    />
  );
}
